import { hbs } from 'ember-cli-htmlbars';
export default hbs("<label for={{@guid}} class={{unless @classless \"tpk-textarea-label\"}} ...attributes>\n  {{yield}}\n</label>")